import { render, staticRenderFns } from "./ShipmentTotal.vue?vue&type=template&id=547432f8&scoped=true&"
import script from "./ShipmentTotal.vue?vue&type=script&lang=js&"
export * from "./ShipmentTotal.vue?vue&type=script&lang=js&"
import style0 from "./ShipmentTotal.vue?vue&type=style&index=0&id=547432f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547432f8",
  null
  
)

export default component.exports